export default __webpack_public_path__ + "static/media/icon-called.fbce3a6d.svg";